import React from 'react';
import { Heading } from 'react-aria-components';

const modalDialogHeader = "_modal-dialog-header_1yzlq_1";
const styles = {
	modalDialogHeader: modalDialogHeader
};

const ModalDialogHeader = ({ children, textAlign = "start" }) => {
  return React.createElement(Heading, { className: styles.modalDialogHeader, "data-text-align": textAlign, "data-zds": true, slot: "title" }, children);
};

export { ModalDialogHeader };
//# sourceMappingURL=Header.es.js.map
